import _chunk from "lodash-es/chunk";
import _uniqueId from "lodash/uniqueId";
import React from 'react';
import { View, Text, Page } from '@react-pdf/renderer';
import { STRING_TRUE } from '@mummssoftware/utils/constants';
import { ios, pageOrientation, pageSize, safari, styles } from '../../utils';
import { PrintHeaderPDFComponent } from '../Header';
import { PrintFooterPDFComponent } from '../Footer';
import defaults from '../../translations/en.json';
import { TaskWeek } from './TaskWeek';

const NoPatientAssistanceComponent = () => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter, styles.marginTopPointFiveCm]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, defaults.noPatientAssistance));

const PatientAssistanceRows = ({
  includePdfTasksNotes,
  pdfTasksNotes,
  pdfWeeklyTasks,
  withDetails
}) => {
  const groupedRows = Object.groupBy(pdfWeeklyTasks, element => element.weekstart);
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(groupedRows).map(week => /*#__PURE__*/React.createElement(TaskWeek, {
    key: week,
    week: week,
    tasks: groupedRows[week],
    withDetails: withDetails,
    includeNotes: includePdfTasksNotes,
    notes: pdfTasksNotes
  })));
};

var _ref = /*#__PURE__*/React.createElement(PrintFooterPDFComponent, null);

const PatientAssistancePage = ({
  browser,
  patient,
  pdfWeeklyTasks,
  includePdfTasksNotes,
  pdfTasksNotes,
  withDetails
}) => /*#__PURE__*/React.createElement(Page, {
  wrap: false,
  size: pageSize,
  orientation: pageOrientation,
  style: browser && browser.name === safari || browser && browser.name === ios ? styles.pageSafari : styles.page
}, /*#__PURE__*/React.createElement(PrintHeaderPDFComponent, {
  browser: browser,
  patient: patient
}), /*#__PURE__*/React.createElement(View, {
  style: [styles.textAlignCenter, styles.width100, styles.marginBottomPointFiveCm]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.printerHeaderText]
}, defaults.completedTasksLog)), /*#__PURE__*/React.createElement(PatientAssistanceRows, {
  includePdfTasksNotes: includePdfTasksNotes,
  pdfTasksNotes: pdfTasksNotes,
  pdfWeeklyTasks: pdfWeeklyTasks,
  withDetails: withDetails
}), _ref); // change size to avoid overflow pages with only 1 or 2 rows


const getPageSize = (details, notes) => {
  if (details && notes) return 16;
  if (details || notes) return 18;
  return 25;
};

var _ref2 = /*#__PURE__*/React.createElement(Page, null, /*#__PURE__*/React.createElement(NoPatientAssistanceComponent, null));

export const PatientAssistancePDF = ({
  browser,
  patient,
  pdfWeeklyTasks,
  includePdfTasksNotes,
  pdfTasksNotes,
  dashboardPrintConfig
}) => {
  const hasData = pdfWeeklyTasks && pdfWeeklyTasks.length > 0;
  const hasTasks = includePdfTasksNotes === STRING_TRUE;
  const tasksConfig = (dashboardPrintConfig === null || dashboardPrintConfig === void 0 ? void 0 : dashboardPrintConfig.PatientAssistance).view;
  const includeDetails = tasksConfig === 'Details'; // cut rows into groups and divide into pages (speeds up rendering to specify Pages)

  const chunkedRows = hasData && _chunk(pdfWeeklyTasks, getPageSize(includeDetails, hasTasks));

  return hasData ? /*#__PURE__*/React.createElement(React.Fragment, null, chunkedRows && chunkedRows.length && chunkedRows.map(taskChunk => /*#__PURE__*/React.createElement(PatientAssistancePage, {
    key: _uniqueId('patient-assistance-page-'),
    browser: browser,
    patient: patient,
    includePdfTasksNotes: hasTasks,
    pdfTasksNotes: pdfTasksNotes,
    pdfWeeklyTasks: taskChunk,
    withDetails: includeDetails
  }))) : _ref2;
};